var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"appointment__index column-index"},[_c('change-store'),_c('column-info',{attrs:{"column-list":_vm.columnListDefault}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }